import React from "react"
import type {AchLimits, AchTotalsDaily, AchTotalsMonthly, AchLimitOverrideInfo} from "../../../../resources/account"
import {LimitOverrideType} from "../../../../resources/account"
import RangeBox from "../../../../components/RangeBox/RangeBox"
import {LimitsPageBlockHeader} from "../LimitsPageBlockHeader"
import {buildAchOverrideInfoProp, getEffectiveAchLimit} from "../helpers"

const achLimitItems: {
	title: string
	description: string
	overrideType: LimitOverrideType
	limitKey: keyof AchLimits
	softLimitKey?: keyof AchLimits
	totalKey: "totalsDaily" | "totalsMonthly"
	totalField: "credits" | "debits"
}[] = [
	{
		title: "Credit",
		description: "(Daily Limit)",
		overrideType: LimitOverrideType.AchDailyCredit,
		limitKey: "dailyCredit",
		totalKey: "totalsDaily",
		totalField: "credits",
	},
	{
		title: "Debit",
		description: "(Daily Limit)",
		overrideType: LimitOverrideType.AchDailyDebit,
		limitKey: "dailyDebit",
		softLimitKey: "dailyDebitSoft",
		totalKey: "totalsDaily",
		totalField: "debits",
	},
	{
		title: "Credit",
		description: "(Monthly Limit)",
		overrideType: LimitOverrideType.AchMonthlyCredit,
		limitKey: "monthlyCredit",
		totalKey: "totalsMonthly",
		totalField: "credits",
	},
	{
		title: "Debit",
		description: "(Monthly Limit)",
		overrideType: LimitOverrideType.AchMonthlyDebit,
		limitKey: "monthlyDebit",
		softLimitKey: "monthlyDebitSoft",
		totalKey: "totalsMonthly",
		totalField: "debits",
	},
]

export function AchLimitsSection({
	limits,
	total,
	onEditLimit,
	override,
}: {
	limits: AchLimits
	total: {totalsDaily: AchTotalsDaily; totalsMonthly: AchTotalsMonthly}
	onEditLimit?: (limitType: LimitOverrideType) => void
	override?: AchLimitOverrideInfo
}) {
	return (
		<div className="account-limits-page-section">
			<LimitsPageBlockHeader title="Originated ACH Payments Limits" icon="money-transfer--business-products" />

			<div className="account-limits-page-grid">
				{achLimitItems.map(({title, description, overrideType, limitKey, softLimitKey, totalKey, totalField}) => (
					<RangeBox
						key={overrideType}
						title={title}
						description={description}
						className="account-limits-page-range-box"
						max={getEffectiveAchLimit(limits[limitKey], override, overrideType)}
						current={total[totalKey][totalField]}
						softLimit={softLimitKey ? limits[softLimitKey] : undefined}
						onEdit={onEditLimit ? () => onEditLimit(overrideType) : undefined}
						overrideInfo={buildAchOverrideInfoProp(override, overrideType, limits[limitKey])}
					/>
				))}
			</div>
		</div>
	)
}
